//@ts-nocheck
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../app/hooks';
import CreateMeeting from './CreateMeeting';
import CustomMenuDropdown from '../../common/CustomMenuDropdown';
import { format } from 'date-fns';
import { deleteMeetingData, fetchMeetingList } from '../../../features/meeting/MeetingSlice';
import { ExclamationIcon } from '../../icons';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { CrossIcon } from '../../icons/Icons';
import UpdateMeeting from './UpdateMeeting';
import { toast } from 'sonner';
import Badge from '../../common/Badge';


function MeetingSection({ applicationDetails, job: jobProp, app: appProp, quickData, onQuestionnaireAction }: any) {
  // const { baseId, jobId, applicationId, skillId } = useParams<{ baseId: string; jobId: string; applicationId: string; skillId: string }>();
  const { baseId, jobId: jobIdFromParams, applicationId: applicationIdFromParams, skillId } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
    skillId: string
  }>();

  const jobId = jobProp || jobIdFromParams;
  const applicationId = appProp || applicationIdFromParams || quickData
  const dispatch = useAppDispatch();
  const [openMeeting, setOpenMeeting] = useState(false);

  // Local state for meetings data
  const [meetingList, setMeetingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate()
  const [openDeleteModalExp, setOpenDeleteModalExp] = useState(false)
  const [deleteLoadingExp, setDeleteLoadingExp] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [editMeeting, setEditMeeting] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState(null);



  // Fetch meetings when component mounts
  useEffect(() => {
    if (baseId && applicationId) { // Ensure both baseId and appId are available
      setLoading(true);
      dispatch(fetchMeetingList({ baseId: parseInt(baseId), appId: applicationId })) // Pass an object with baseId and appId
        .unwrap()
        .then((response) => {
          setMeetingList(response.data); // Set the data array from response
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching meetings:", error);
          setError(error.toString());
          setLoading(false);
        });
    }
  }, [dispatch, baseId, applicationId]);

  const handleMeeting = () => {
    setOpenMeeting(true);
  };

  // Format date for display, using date and from_time/till_time from API
  const formatDate = (date, fromTime, tillTime) => {
    try {
      // Combine date and time for display
      const meetingDate = new Date(`${date}T${fromTime}`);
      const endTime = new Date(`${date}T${tillTime}`);
      

      return {
        day: format(meetingDate, 'd'),
        month: format(meetingDate, 'MMM'),
        fullDate: format(meetingDate, 'EEEE, MMMM d'),
        time: `${format(meetingDate, 'h:mm a')} - ${format(endTime, 'h:mm a')}`
      };
    } catch (error) {
      console.error("Error formatting date:", error);
      return {
        day: "N/A",
        month: "N/A",
        fullDate: "Invalid date",
        time: "N/A"
      };
    }
  };


  // const handleMeetingDetails = (meeting: any) => {
  //   navigate(`/${baseId}/job/${jobId}/app/${applicationId}/meetings/${meeting}`)
  // }

  const handleMeetingDetails = (meeting: any) => {
    if (onQuestionnaireAction) {
      // Use the callback provided by parent component
      onQuestionnaireAction(meeting);
    } else {
      // Default behavior - navigate to the route
      navigate(`/${baseId}/job/${jobId}/app/${applicationId}/meetings/${meeting}`)
    }
  }


  const handleDeleteClick = (edu, index) => {
    setSelectedIndex(edu); // Store the index to be deleted
    setOpenDeleteModalExp(true); // Open the confirmation modal
  };

  // Function to handle cancel button in delete modal
  const handleCloseModal = () => {
    setOpenDeleteModalExp(false);
    setSelectedIndex(null); // Clear the selected index
  };


  const handleDeleteConfirm = async () => {
    setDeleteLoadingExp(true); // Start loading

    try {
      await dispatch(
        deleteMeetingData({
          baseId: Number(baseId),
          id: selectedIndex?.id,
        })
      ).unwrap();

      toast.success("Meeting deleted successfully!");
      setOpenDeleteModalExp(false);
      // setSelectedFile(null)


      const res = await dispatch(
        fetchMeetingList({
          baseId: Number(baseId),
          appId: applicationId,  // Change appID to appId to match the original call
        })
      ).unwrap();

      if (res.status === 200) {
        setMeetingList(res.data);
      }

    } catch (error) {
      toast.error("Failed to delete meeting!");
      console.error("Delete error:", error);
    } finally {
      setDeleteLoadingExp(false); // Stop loading
    }
  };

  // Ensure selectedMeeting is only updated when necessary
  const handleSelectMeeting = useCallback((meeting) => {
    setSelectedMeeting(meeting);
  }, []);


  const handleEditClick = (meeting) => {    
    setSelectedMeeting(meeting);
    setEditMeeting(true);
  };




  return (
    <div>
      <div className='flex items-center justify-between'>
        <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize">Meetings</h2>
        <button
          onClick={handleMeeting}
          className="group inline-flex shrink-0 select-none items-center justify-end text-[.8125rem] leading-6 transition-colors 
          duration-100 focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none 
          gap-0 px-[14px] font-medium  py-1 rounded-md text-white bg-indigo-600 h-[32px] hover:bg-indigo-500 focus-visible:outline-indigo-600"
          type="button"
        >
          <div className="flex items-center gap-[6px]">Create Meeting</div>
        </button>
      </div>
      <div className='bg-[#e0e0e0] w-full h-[1px] my-6'></div>

      {/* Loading state */}
      {loading && (
        <div className="flex items-center justify-center relative z-50" style={{ height: 'calc(100vh - 191px)' }}>
          <div className="simple-spinner-loader">
            <span></span>
          </div>
        </div>
      )}

      {/* Error state */}
      {error && (
        <div className="text-center py-4 text-red-500">
          Error: {error}
        </div>
      )}

      {/* No meetings state */}
      {!loading && !error && (!meetingList || meetingList.length === 0) && (
        <div className='w-full mt-5 flex h-[300px] justify-center items-center flex-col gap-y-3'>
          <ExclamationIcon />
          <p className='text-[#0000007a] text-[13px]'>No results found</p>
        </div>
      )}

      {/* Meeting list */}
      {!loading && !error && meetingList && meetingList.length > 0 && (
        <div className="space-y-4">
          {meetingList.map((meeting, index) => {
            const dateInfo = formatDate(meeting.date, meeting.from_time, meeting.till_time);


            const dropdownGroups = [
              {
                options: [
                  {
                    label: `Edit`,
                    className:
                      "py-[0.375rem] px-[0.75rem] bg-white text-[#000000eb] text-[13px] hover:bg-[#e7e7e8]",
                    onClick: () => handleEditClick(meeting, index),
                  },
                  {
                    label: `Delete`,
                    className:
                      "py-[0.375rem] px-[0.75rem] bg-white text-[#000000eb] text-[13px] hover:bg-[#e7e7e8]",
                    onClick: () => handleDeleteClick(meeting, index),
                  },
                ],
              },
            ];


            return (
              <div key={meeting.id} className='rounded-md p-4 cursor-pointer ring-1 ring-gray-200 feedback-delete-hover'>
                <div className='flex items-start'>
                  <div className='flex flex-row w-[82%] gap-x-4'
                    onClick={() => handleMeetingDetails(meeting.id)}

                  >
                    <div className='w-[10%]'>
                      <div className='flex flex-col items-start border border-solid border-[#00230014] rounded-[6px]'>
                        {
                          dateInfo.month &&
                          <div className='bg-[#00230014] text-[10px] font-bold p-[2px] uppercase text-[#20808D] w-full text-center leading-5 rounded-t-[6px]'>
                            {dateInfo.month}
                          </div>
                        }
                        {
                          dateInfo.day &&
                          <div className='text-[#1b1b1b] text-[16px] font-medium text-center w-full'>
                            {dateInfo.day}
                          </div>
                        }

                      </div>
                    </div>
                    <div className='[90%]'>
                      {
                        meeting.details &&
                        <h2 className='text-sm text-[#374151] font-medium leading-5 capitalize mt-[-2px]'>{meeting.details}</h2>
                      }
                      {
                        dateInfo.fullDate &&
                        <div className='text-xs leading-4 text-gray-500 mt-[2px]'>
                          {dateInfo.fullDate}
                          {
                            dateInfo.time &&
                            <span className='ml-1'>
                              -    {dateInfo.time}
                            </span>
                          }
                        </div>
                      }


                      {/* <div className='text-xs leading-4 text-gray-500 mt-1'>Location: {meeting.location || "N/A"}{meeting.location_details ? ` - ${meeting.location_details}` : ""}</div> */}
                    </div>

                  </div>

                  <div className='w-[18%] flex items-start justify-end'>
                    <div className=' table-tooltip flex items-center max-w-fit gap-[6px]'>
                      {
                        meeting.current_state === 'done' ? (
                          <span
                            className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 capitalize "
                          // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
                          >
                            {meeting.current_state}
                          </span>
                        ) : meeting.current_state === 'pending' ? (
                          <span
                            className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20 capitalize"
                          // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
                          >
                            {meeting.current_state}
                          </span>

                        ) : meeting.current_state === 'close' ? (
                          <span
                            className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10 capitalize"
                          // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
                          >
                            {meeting.current_state}
                          </span>
                        ) : meeting.current_state === 'cancelled' ? (
                          <span
                            className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10 capitalize"
                          // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
                          >
                            {meeting.current_state}
                          </span>
                        ) : meeting.current_state === 'scheduled' ? (
                          <span
                            className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 capitalize"
                          >
                            {meeting.current_state}
                            {/* completed-payment */}
                          </span>
                        ) :
                          null}
                    </div>
                    {/* [&>div]:shrink feedback-delete-btn-hover */}
                    <div className="">
                      <CustomMenuDropdown
                        sections={dropdownGroups}
                        icon={
                          <svg
                            stroke="currentColor"
                            fill="none"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                            focusable="false"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="12" cy="12" r="1"></circle>
                            <circle cx="12" cy="5" r="1"></circle>
                            <circle cx="12" cy="19" r="1"></circle>
                          </svg>
                        }
                        menuItemsClassName="left-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <CreateMeeting
        opneMeeting={openMeeting}
        setOpenMeeting={setOpenMeeting}
        applicationDetails={applicationDetails}
        meetingList={meetingList}
        setMeetingList={setMeetingList}
        quickData={quickData}

      />


      <UpdateMeeting
        opneMeeting={editMeeting}
        setOpenMeeting={setEditMeeting}
        applicationDetails={applicationDetails}
        meetingList={meetingList}
        setMeetingList={setMeetingList}
        selectedMeeting={selectedMeeting} // Add this prop
        quickData={quickData}
      />


      {openDeleteModalExp && (
        <Dialog open={true} onClose={handleCloseModal} className="relative z-10">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    <span className="sr-only">Close</span>
                    <CrossIcon />
                  </button>
                </div>
                <div className="flex flex-col gay-y-4">
                  <span className="leading-6 text-sm text-gray-500">
                    Do you want to sure delete this Meeting?
                  </span>
                </div>
                <div className="mt-5 sm:mt-4 flex gap-2 justify-end">
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="items-center px-[14px] py-1 text-[13px] font-medium h-[32px] inline-flex leading-6 w-fit justify-center rounded-md bg-white  text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDeleteConfirm}
                    type="button"
                    className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 "
                  >
                    {deleteLoadingExp ? (
                      <div className='flex items-center gap-[6px]'>
                        Delete
                        <div className="simple-spinner">
                          <span></span>
                        </div>
                      </div>
                    ) : (
                      'Delete'
                    )}
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      )}






    </div>
  );
}

export default MeetingSection;